import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NavBar from "../communs/NavBar";
import FooterSection from "../../components/sections/FooterSection";
import HeroSectionDetailsProject from "./layout-details-project/HeroSectionDetailsProject";
import Loader from "../../biblio/Loader/Loader";
import headerBg from "../../assets/images/seasonal-projects.png";
import headerMobileBg from "../../assets/background/seasonal-projects-Mob.png";
import {
  getAllProjectsTypes,
  getBranchProjects,
  getProjectBranches,
} from "../../apis/actions/projects.actions";
import { AppDispatch, RootState } from "../../apis/store";
import ComposedCard from "../../biblio/Cards/ComposedCard";
import PaginationComponent from "../../biblio/Pagination/PaginationComponent";
import pray from "../../assets/icons/SelectIcon.svg";
import { ConfigProvider, Empty, Input, Select } from "antd";
import PrimaryButton from "../../biblio/Buttons/PrimaryButton";
import { LeftOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { scroll } from "../../components/utils/utils";

const { Search } = Input;
const itemPerPage = 8;

const BranchProjectsList: React.FC = () => {
  const { branchId } = useParams<{ branchId: string }>();
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const currentRef = useRef<HTMLDivElement>(null);

  const branchProjects = useSelector(
    (state: RootState) => state?.projects?.branchProjects
  );
  const projectBranches = useSelector(
    (state: RootState) => state?.projects?.projectBranches
  );
  const projectTypes = useSelector(
    (state: RootState) => state?.projects?.projectTypes
  );

  const [selectedProjectType, setSelectedProjectType] = useState<any>(null);
  const [selectedTypeId, setSelectedTypeId] = useState<number | null>(null);
  const [active, setActive] = useState<number>(1);
  const [loading, setLoading] = useState(true);
  const [projectName, setProjectName] = useState("");
  const [filteredProject, setFilteredProject] = useState<any[]>([]);

  useEffect(() => {
    dispatch(getProjectBranches());
    dispatch(getAllProjectsTypes());
  }, [dispatch]);

  // Fetch projects whenever the branch in the URL changes
  useEffect(() => {
    if (branchId) {
      dispatch(getBranchProjects(Number(branchId)));
    }
  }, [branchId, dispatch]);

  // Reset filters and sync displayed list when API returns new projects
  useEffect(() => {
    setFilteredProject(branchProjects);
    setSelectedProjectType(null);
    setSelectedTypeId(null);
    setProjectName("");
    setActive(1);
  }, [branchProjects]);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, [branchProjects]);

  const updateActive = (nb: number) => {
    setActive(nb);
    scroll(currentRef);
  };

  // Changing branch navigates to the new URL; the useEffect above re-fetches
  const handleBranchChange = (newBranchId: number) => {
    navigate(`/branch-projects/${newBranchId}`);
  };

  const onSearch = (typeFilter: any, nameFilter: string) => {
    setActive(1);
    if (typeFilter === null && nameFilter === "") {
      setFilteredProject(branchProjects);
      return;
    }
    setFilteredProject(
      branchProjects.filter(
        (project: any) =>
          (!typeFilter || project.request_type_id === typeFilter) &&
          (!nameFilter ||
            project.project_name.includes(nameFilter) ||
            project.brief.includes(nameFilter))
      )
    );
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="takaful--projects-container">
      <NavBar variant="projectDetails" />
      <HeroSectionDetailsProject
        title="المشاريع"
        subTitle="مشاريع الفروع"
        urlImage={headerBg}
        mobileImage={headerMobileBg}
        type="المشاريع"
      />

      {/* Filter Bar */}
      <div
        className="takaful--cases-section"
        style={{ marginTop: "2vh" }}
        ref={currentRef}
      >
        <div className="takaful--cases-header">
          <div className="takaful--cases-header-content">

            {/* Branch select — preselected with the URL param */}
            <div className="takaful--cases-header-box">
              <ConfigProvider
                renderEmpty={() => (
                  <Empty
                    description={
                      <span className="takaful--select-empty">
                        لا توجد بيانات
                      </span>
                    }
                  />
                )}
              >
                <Select
                  showSearch
                  popupMatchSelectWidth={300}
                  className="takaful--select takaful--selects"
                  size="large"
                  placeholder="اختر الفرع"
                  value={branchId ? Number(branchId) : undefined}
                  onChange={(val: number) => handleBranchChange(val)}
                  options={projectBranches?.map((branch: any) => ({
                    label: branch.name,
                    value: branch.id,
                  }))}
                  dropdownRender={(menu: any) => (
                    <div className="takaful--select-dropdown">{menu}</div>
                  )}
                />
              </ConfigProvider>
            </div>

            {/* Project type select */}
            <div className="takaful--cases-header-box">
              <img src={pray} alt="" />
              <ConfigProvider
                renderEmpty={() => (
                  <Empty
                    description={
                      <span className="takaful--select-empty">
                        لا توجد بيانات
                      </span>
                    }
                  />
                )}
              >
                <Select
                  key="project-type"
                  showSearch
                  popupMatchSelectWidth={300}
                  className="takaful--select takaful--selects"
                  size="large"
                  placeholder="اختر نوع المشروع"
                  value={selectedTypeId ?? undefined}
                  onChange={(e: any) => {
                    const type = e
                      ? projectTypes.filter((el: any) => el.id === e)[0]?.name
                      : null;
                    setSelectedTypeId(e ?? null);
                    setSelectedProjectType(type);
                  }}
                  options={projectTypes.map((option: any) => ({
                    label: option.name,
                    value: option.id,
                  }))}
                  dropdownRender={(menu: any) => (
                    <div className="takaful--select-dropdown">{menu}</div>
                  )}
                  allowClear
                  onClear={() => {
                    setSelectedTypeId(null);
                    setSelectedProjectType(null);
                    onSearch(null, projectName);
                  }}
                />
              </ConfigProvider>
            </div>

            <Search
              className="takaful--search"
              placeholder="ادخل كلمة البحث"
              allowClear
              enterButton
              value={projectName}
              onPressEnter={() => onSearch(selectedProjectType, projectName)}
              onClear={() => onSearch(selectedProjectType, "")}
              type="text"
              onChange={(e) => setProjectName(e.target.value)}
            />
            <PrimaryButton
              className="takaful--primary-button"
              icon={<LeftOutlined />}
              title={t("cases.button")}
              onClick={() => onSearch(selectedProjectType, projectName)}
            />
          </div>
        </div>
      </div>

      {/* Projects Grid */}
      <div>
        <div className="takaful--cases-section">
          <div className="takaful--cases" style={{ marginTop: "3rem" }}>
            {branchProjects.length === 0 ? (
              <p className="takaful--no-project-message">لا يوجد مشاريع</p>
            ) : filteredProject.length === 0 ? (
              <p className="takaful--no-project-message">
                لا يوجد مشاريع تتوافق مع البحث الذي قمت به
              </p>
            ) : (
              filteredProject
                .slice(itemPerPage * (active - 1), itemPerPage * active)
                .map((project: any, index: number) => (
                  <ComposedCard
                    donation_type_ids={project.donation_type_ids}
                    key={index}
                    type="المشاريع"
                    project={project}
                    cardClass="card-1"
                  />
                ))
            )}
          </div>
        </div>
      </div>

      {filteredProject && filteredProject.length > itemPerPage && (
        <PaginationComponent
          active={active}
          scroll={() => scroll(currentRef)}
          total={filteredProject.length}
          itemPerPage={itemPerPage}
          setActive={(nb) => updateActive(nb)}
        />
      )}

      <FooterSection />
    </div>
  );
};

export default BranchProjectsList;
